const config = {
    ConcertClient: {
        SERVICE_ID: 'ATOZ_CONCERT_SERVICE',
        ENDPOINT: 'graphql',
        DEFAULT_TIMEOUT: 5 * 1000,
        CACHE_REFRESH_TIMEOUT: 20 * 1000,
        INTERVAL_TO_CACHE_REFRESH: 15 * 60 * 1000, // 15 min
    },
    ReactQuery: {
        QUERY_CACHE_TIME: 1000 * 60 * 60 * 24,
        PERSIST_CACHE_MAX_AGE: 1000 * 60 * 60 * 24, // 24 hours
    },
};
export default config;
//# sourceMappingURL=config.js.map